import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class GoogleAnalytics implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_GOOGLE_ANALYTICS;
  label: string = 'Google Analytics';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = false;

  getClientIdRegexp(): RegExp {
    return /^(G|UA)-[a-z0-9-]+$/i;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
